
import { TemplateObjectsService } from './template-process/services/template-objects.service';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { EditTemplateDialog } from './edit-template-dialog/edit-template-dialog.component';
import { Utils } from 'formiojs';
import download from 'downloadjs';
import { FormioLoader, FormioCustomComponent, ResourceNameService, ViewerComponent } from 'dp-formio';

@Component({
  selector: 'app-template-wrapper',
  templateUrl: './template-wrapper.component.html',
  // styleUrls: ['./template-wrapper.component.scss']
  encapsulation: ViewEncapsulation.None,
  providers: [FormioLoader]
})
export class TemplateWrapperComponent implements FormioCustomComponent<any>, OnDestroy, OnChanges {
  dir: 'rtl' | 'ltr';
  @Input() required: boolean;

  @Input()
  value: any = {};

  @Output()
  valueChange = new EventEmitter<any>();

  @Input()
  disabled: boolean;

  @Input()
  viewOnly: boolean;

  @Input()
  data: any;

  @Input()
  customOptions: any;

  @Input()
  formioComponent: any;

  private subs: Subscription[] = [];
  set sub(s: Subscription) { this.subs.push(s); }

  selectedTemplate: any;
  resource = '';
  query = '';
  templates: any[] = [];

  evaluatedTemplate: any;
  baseValue: any;

  constructor(private translateService: TranslateService,
    private dialog: MatDialog,
    private resourceNameService: ResourceNameService,
    private templateObjectsService: TemplateObjectsService,
    private formloader: FormioLoader) {
    this.changeDirection(this.translateService.currentLang);
    this.sub = this.translateService.onLangChange.subscribe(data => {
      this.changeDirection(data.lang);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.customOptions && this.customOptions.resource) {
      this.resource = this.customOptions.resource;
      if (this.customOptions.query)
        this.query = this.formioComponent.interpolate(this.customOptions.query, { data: this.data });
      this.getTemplatesResources();
    }
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
    this.subs = [];
  }

  changeTemplate(event) {
    if (!event) {
      this.evaluatedTemplate = null;
      this.notifyValue();
      return;
    }
    console.log(event);

    this.evaluatedTemplate = null;
    this.sub = this.resourceNameService.loadCustomByKeyId(this.resource, event._id)
      .subscribe(res => {
        this.selectedTemplate.res = res;
        this.editTemplate();
      });
  }

  editTemplate(base64: string = null) {
    this.formloader.loading = true;
    this.sub = this.templateObjectsService.getRequestData(this.data.requestDetails.data.currentRoute.split('?case=')[1])
      .subscribe(requestData => {
        this.templateObjectsService.PROCESS_HOST_URL = this.selectedTemplate.processHostUrl;
        const fields = [];

        const flattenData = this.flatten(this.data);
        //remove brackets from any phone number
        Object.keys(flattenData).forEach(key => {
          if (/^\([0-9]{5}\)[0-9]{9}$/i.test(flattenData[key]))
            flattenData[key] = flattenData[key].replace(/\(|\)/g, '');
        });

        //localizedFields
        this.selectedTemplate.res.data.localizedFields.forEach(key => {
          if (flattenData[key]) flattenData[key] = this.translateService.instant(`forms.common.${flattenData[key]}`);
        });

        for (const [key, value] of Object.entries(flattenData)) {
          const keyParts = key.split('_');
          if (value === '' || typeof value == 'number' || typeof value == 'string' || value instanceof Date || value instanceof Boolean) {
            fields.push({ key: `\${${key}}`, label: this.translateService.instant(keyParts[keyParts.length - 1]) });
          }
          else if (value instanceof Array && value.length) {
            if (value[0] === '' || typeof value == 'number' || typeof value == 'string' || value[0] instanceof Date || value instanceof Boolean) {
              fields.push({ key: `\${${key}}`, label: this.translateService.instant(keyParts[keyParts.length - 1]) });
            }
          }
        }

        const selectedTemplate = {
          requestType: requestData[0].serviceId,
          requestId: requestData[0].data,
          uid: this.selectedTemplate.res._id,
          // uid: base64 ? '' : this.selectedTemplate.res._id,
          referenceNumber: this.selectedTemplate.res.data.order,
          creationDate: new Date(),
          name: this.translateService.instant(`forms.common.${this.selectedTemplate.res.data.value}`),
          fields
        };

        document.dir = 'ltr';
        const dialogRef = this.dialog.open(EditTemplateDialog, {
          width: '100vw',
          maxWidth: '100vw',
          height: '100vh',
          panelClass: 'template-wrapper-dialog',
          data: {
            dir: this.dir,
            selectedTemplate,
            data: flattenData
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          document.dir = this.translateService.currentLang === 'ar' ? 'rtl' : 'ltr';
          if (result && result.evaluated) {
            console.log(result);
            this.evaluatedTemplate = result.evaluated;
          } else {
            if (!base64) this.initByValue();
          }
          this.notifyValue();
        });
        this.formloader.loading = false;
      }, error => {
        this.formloader.loading = false;
      });
  }

  downloadTemplateFile() {
    download("data:application/pdf;base64," + encodeURI(this.evaluatedTemplate), this.evaluatedTemplateName, 'pdf');
  }
  viewTemplateFile(isTemplate: boolean = false) {
    const dailog = this.dialog.open(ViewerComponent, {
      position: { top: '0', right: '0' },
      data: {
        data: {
          originalName: this.evaluatedTemplateName,
          url: "data:application/pdf;base64," + encodeURI(this.evaluatedTemplate)
        },
        dir: this.dir,
        annotationEnabled: false
      },
      height: '100vh',
      width: '100vw',
      panelClass: 'full-screen-modal',
    });
    if (this.viewOnly) this.updateAfterOpen();
  }

  private changeDirection(lang) {
    this.dir = null;
    setTimeout(() => { this.dir = lang === 'ar' ? 'rtl' : 'ltr'; });
  }
  private getTemplatesResources() {
    this.formloader.loading = true;
    this.sub = this.resourceNameService.loadCustomByFilterdKey(this.resource, this.query)
      .subscribe(data => {
        this.templates = data.map(q => {
          return {
            _id: q._id,
            ...q.data,
            value: this.translateService.instant(`forms.common.${q.data.value}`),
            template: q.data.template[0]
          };
        }).sort(function (a, b) {
          if (a.order < b.order) { return -1; }
          else if (a.order > b.order) { return 1; }
          else { return 0; }
        });
        console.log(this.templates);
        if (this.value) {
          this.baseValue = { ...this.value };
          this.initByValue();
        }
        this.formloader.loading = false;
      }, error => {
        this.formloader.loading = false;
      });
  }

  private initByValue() {
    if (this.baseValue && Object.keys(this.baseValue.selectedTemplate).length) {
      this.selectedTemplate = this.baseValue.selectedTemplate;
      this.evaluatedTemplate = this.baseValue.evaluated;
    } else {
      this.selectedTemplate = null;
      this.evaluatedTemplate = null;
    }
  }

  private notifyValue() {
    if (!this.selectedTemplate && this.required) {
      this.value = null;
    } else {
      const result = {
        selectedTemplate: this.selectedTemplate,
        evaluated: this.evaluatedTemplate
      };

      this.value = result;
    }
    this.valueChange.emit(this.value);
  }

  private traverseAndFlatten(currentNode, target, flattenedKey = null) {
    for (var key in currentNode) {
      if (currentNode.hasOwnProperty(key)) {
        var newKey;
        if (flattenedKey === undefined) {
          newKey = key;
        } else {
          newKey = flattenedKey ? flattenedKey + '_' + key : key;
        }

        var value = currentNode[key];
        if (typeof value === "object") {
          this.traverseAndFlatten(value, target, newKey);
        } else {
          target[newKey] = value;
        }
      }
    }
  }

  private flatten(obj) {
    var flattenedObject = {};
    this.traverseAndFlatten(obj, flattenedObject);
    return flattenedObject;
  }

  private updateAfterOpen() {
    if (this.customOptions && this.customOptions.afterOpen)
      this.customOptions.afterOpen.forEach(item => {
        const components = Utils.searchComponents(this.formioComponent.root.components, { key: item.key });
        components.forEach(c => {
          const value = this.formioComponent.interpolate(item.value, { data: this.data });
          c.setValue(value);
        });
      });
  }

  get evaluatedTemplateName() {
    const nameSegments = this.selectedTemplate.template.originalName.split('.');
    return nameSegments.slice(0, nameSegments.length - 1).join('.') + '.pdf';
  }
}
